/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Container, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";
import Constants from "../../utilities/Constants";
import Strings from "../../utilities/StringSelector";
import Utils from "../../utilities/Utils";

const UtilsInstance = new Utils();

export class TsExpertConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,

      isTerminationOFFProblemChecked: false,
      isCapacitiveEffectChecked: false,
      isHighResistanceProblemChecked: false,
      isInvertedPolarityChecked: false,
      isNoiseProblemChecked: false,
      isDadosProblemChecked: false,
      isUnbalanceProblemChecked: false,
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig/" + this.props.channel, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isTerminationOFFProblemChecked: data.isTerminationOFFProblemChecked,
        isCapacitiveEffectChecked: data.isCapacitiveEffectChecked,
        isHighResistanceProblemChecked: data.isHighResistanceProblemChecked,
        isInvertedPolarityChecked: data.isInvertedPolarityChecked,
        isNoiseProblemChecked: data.isNoiseProblemChecked,
        isDadosProblemChecked: data.isDadosProblemChecked,
        isUnbalanceProblemChecked: data.isUnbalanceProblemChecked,
      }));
  }

  // ------ Toggle Checkboxes ---------
  toggleIsTerminationOFFProblemChecked = () => {
    this.setState({ isTerminationOFFProblemChecked: !this.state.isTerminationOFFProblemChecked });
  }

  toggleIsCapacitiveEffectChecked = () => {
    this.setState({ isCapacitiveEffectChecked: !this.state.isCapacitiveEffectChecked });
  }

  toggleIsHighResistanceProblemChecked = () => {
    this.setState({ isHighResistanceProblemChecked: !this.state.isHighResistanceProblemChecked });
  }

  toggleIsisInvertedPolarityChecked = () => {
    this.setState({ isInvertedPolarityChecked: !this.state.isInvertedPolarityChecked });
  }

  toogleIsNoiseProblemChecked = () => {
    this.setState({ isNoiseProblemChecked: !this.state.isNoiseProblemChecked });
  }

  toogleIsDadosProblemChecked = () => {
    this.setState({ isDadosProblemChecked: !this.state.isDadosProblemChecked });
  }
  toogleIsUnbalanceProblemChecked = () => {
    this.setState({ isUnbalanceProblemChecked: !this.state.isUnbalanceProblemChecked });
  }

  // Save the TS Expert Configuration
  saveTsExpertConfiguration = () => {
    this.showSendingConfigDimmer();

    let data = {
      isTerminationOFFProblemChecked: this.state.isTerminationOFFProblemChecked,
      isCapacitiveEffectChecked: this.state.isCapacitiveEffectChecked,
      isHighResistanceProblemChecked: this.state.isHighResistanceProblemChecked,
      isInvertedPolarityChecked: this.state.isInvertedPolarityChecked,
      isNoiseProblemChecked: this.state.isNoiseProblemChecked,
      isDadosProblemChecked: this.state.isDadosProblemChecked,
      isUnbalanceProblemChecked: this.state.isUnbalanceProblemChecked,
    };

    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig_POST/" + this.props.channel, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.ERROR_REASON + error);
      })
      .finally(this.hideSendingConfigDimmer);
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });

  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Container>

        <Segment>
          <Header as='h2' textAlign="center" color="teal">
            {Strings.TS_EXPERT_CONFIGURATION}
          </Header>
          <Divider clearing />

          <Segment id="problems-list" style={listSegmentStyle} basic>

            <List divided verticalAlign='middle'>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.PA_TERMINATOR_OFF_LIST_HEADER}</List.Header>
                      {Strings.PA_TERMINATOR_OFF_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsTerminationOFFProblemChecked}
                        checked={this.state.isTerminationOFFProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.PA_CAPACITIVE_EFFECT_LIST_HEADER}</List.Header>
                      {Strings.PA_CAPACITIVE_EFFECT_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsCapacitiveEffectChecked}
                        checked={this.state.isCapacitiveEffectChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.PA_HIGH_RESISTANCE_LIST_HEADER}</List.Header>
                      {Strings.PA_HIGH_RESISTANCE_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsHighResistanceProblemChecked}
                        checked={this.state.isHighResistanceProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.PA_INVERTED_POLARITY_LIST_HEADER}</List.Header>
                      {Strings.PA_INVERTED_POLARITY_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsisInvertedPolarityChecked}
                        checked={this.state.isInvertedPolarityChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.PA_NOISE_LIST_HEADER}</List.Header>
                    {Strings.PA_NOISE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toogleIsNoiseProblemChecked}
                      checked={this.state.isNoiseProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.PA_DADOS_LIST_HEADER}</List.Header>
                    {Strings.PA_DADOS_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toogleIsDadosProblemChecked}
                      checked={this.state.isDadosProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.PA_UNBALANCE_LIST_HEADER}</List.Header>
                    {Strings.PA_UNBALANCE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toogleIsUnbalanceProblemChecked}
                      checked={this.state.isUnbalanceProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

            </List>

          </Segment>

          <Button
            fluid
            color="teal"
            content={Strings.SAVE}
            onClick={this.saveTsExpertConfiguration} />

          <Dimmer active={this.state.isSendingConfigDimmerActive} >
            <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
          </Dimmer>

        </Segment>

      </Container>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "310px"
};

export default TsExpertConfig;
